import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import BeLaunchifiedCard from "./BeLaunchifiedCard";
import "./BeLaunchified.css";
import {
  loadCoursesToShow,
  fetchCourses,
} from "../../../Providers/CourseDataProvider";
import { fetchUserLearningPlans } from "../../../Providers/CatalogDataService";
import { getRandomFact } from "./FactLoader";
function BeLaunchifiedComponent() {
  const [factsArray, setFactsArray] = useState([]);
  const [factIndex, setFactIndex] = useState(0);

  const [courseList, setCourseList] = useState([]);
  const [catalogList, setCatalogList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [catalogFilterList, setCatalogFilterList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isClearDisabled, setClearDisabled] = useState(true);

  const [fact, setFact] = useState();
  const [setFade] = useState(true);
  const [displayedFacts, setDisplayedFacts] = useState([]);
  const [orgLearningData, setOrgLearningPlans] = useState([]);
  const [orgLearningLoading, setOrgLearningLoading] = useState(true);
  const [availableCourses, setAvailableCourses] = useState([]);
  const loadOrgLearningPlans = async () => {
    setOrgLearningLoading(true);
    try {
      const res = await fetchUserLearningPlans();
      if (res && Array.isArray(res.orgLearningPlans)) {
        setOrgLearningPlans(res.orgLearningPlans);
      } else {
        setOrgLearningPlans([]);
      }
    } catch (error) {
      console.error("Error fetching org learning plans:", error);
      setOrgLearningPlans([]);
    }
    setOrgLearningLoading(false);
  };
  useEffect(() => {
    loadOrgLearningPlans();
  }, []);

  const handleSearchTxtClear = () => {
    setSearchQuery("");
  };

  const handleCatalogClear = () => {
    setClearDisabled(true);
    setCatalogFilterList([]);
  };

  const handleCatalogSearch = (catalog) => {
    setClearDisabled(false);
    let catalogfilter = [...catalogFilterList];
    if (catalogfilter.includes(catalog)) {
      catalogfilter = catalogfilter.filter((item) => item !== catalog);
    } else {
      catalogfilter.push(catalog);
    }
    setCatalogFilterList(catalogfilter);
  };

  useEffect(() => {
    let catalogFiltered = [];
    if (catalogFilterList.length > 0) {
      catalogFiltered = courseList.filter((item) => {
        return catalogFilterList.includes(item.catalogName);
      });
    } else {
      catalogFiltered = courseList;
    }

    const filtered = catalogFiltered.filter(
      (item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.description.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    setFilteredData(filtered);
  }, [searchQuery, courseList, catalogFilterList]);

  useEffect(() => {
    let catalogs = courseList?.map((course) => course["catalogName"]);
    catalogs = [...new Set(catalogs)];
    setCatalogList(catalogs);
  }, [courseList]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        loadCoursesToShow().then((response) => setAvailableCourses(response));
      } catch (error) {
        console.error("Error API fetching data-", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (orgLearningLoading) return;
    const getUniqueCourses = (courses) => {
      const uniqueKeys = new Set();
      var uniqueCourses = [];
      for (const course of courses) {
        if (!uniqueKeys.has(course.key)) {
          uniqueKeys.add(course.key);
          uniqueCourses = [...uniqueCourses, course];
        }
      }
      return uniqueCourses;
    };
    const orgCourses =
      orgLearningData &&
      Array.isArray(orgLearningData) &&
      orgLearningData.length > 0
        ? orgLearningData.flatMap((plan) =>
            (plan.courses || []).map((course) => ({
              key: `${plan.learningPlanName}-${course.courseName}`,
              title: course.courseName,
              link: course.courseLink,
              duration: "",
              description: plan.description || "",
              status: course.status,
              catalogName: "Curated Courses",
            })),
          )
        : [];
    console.log("org courses", orgCourses);
    const fetchCoursesSequentially = async () => {
      await fetchAndSetCourses("eager");
      await fetchAndSetCourses("lazy");
    };

    const fetchAndSetCourses = async (fetchType) => {
      let courses = await fetchCourses(availableCourses, fetchType);
      if (fetchType === "eager" && availableCourses.length > 0) {
        if (orgCourses.length > 0) {
          courses = [...courses, ...orgCourses];
        }
      }
      courses.sort((courseA, courseB) => {
        if (
          courseA.catalogName === "Launch" &&
          courseA.title === "What is Launch by NTT DATA"
        )
          return -1;
        if (
          courseB.catalogName === "Launch" &&
          courseB.title === "What is Launch by NTT DATA"
        )
          return 1;
        if (courseA.catalogName === "Launch") return -1;
        if (courseB.catalogName === "Launch") return 1;
        if (courseA.catalogName === "Curated Courses") return -1;
        if (courseB.catalogName === "Curated Courses") return 1;
        return courseA.catalogName.localeCompare(courseB.catalogName);
      });
      setCourseList((courseList) =>
        getUniqueCourses([...courseList, ...courses]),
      );
      setLoading(false);
    };
    setLoading(true);
    fetchCoursesSequentially();
  }, [availableCourses, orgLearningData]);

  const updateFact = () => {
    setFade(false);
    setTimeout(() => {
      const {
        fact: newFact,
        reset,
        colorClass,
      } = getRandomFact(displayedFacts);
      setFact(newFact);
      setFade(true);

      if (reset) {
        setDisplayedFacts([]);
      } else {
        setDisplayedFacts((prev) => [...prev, newFact]);
      }
    }, 500);
  };

  useEffect(() => {
    const facts = getRandomFact();
    setFactsArray(facts);
    setFactIndex(0);
    setFact(facts[0]?.fact || "");
  }, [loading]);

  const goToFact = (idx) => {
    setFactIndex(idx);
    setFact(factsArray[idx].fact);
  };

  useEffect(() => {
    if (!loading || factsArray.length === 0) return;
    const interval = setInterval(() => {
      setFactIndex((prev) => {
        const next = (prev + 1) % factsArray.length;
        setFact(factsArray[next].fact);
        return next;
      });
    }, 6000);
    return () => clearInterval(interval);
  }, [loading, factsArray]);

  return (
    <div>
      <Container>
        <Row>
          <div className="arrow-right">
            <a href="#">
              <img src="assets/images/arrowLeft.png" />
            </a>
          </div>
        </Row>
        <Row>
          <Col>
            <div className="launch-academy">Launch Academy</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="be-Launchified">Be Launchified</div>
          </Col>
        </Row>
        <Row className="beLaunchified-course-section">
          <div className="left-panel-div">
            <Row>
              <Col lg={true}>
                <form>
                  <label className="left-panel-head col-ms-6 py-4 fw-bold">
                    Search Insights
                  </label>
                  <div className="search-insights-clear">
                    <button
                      type="button"
                      onClick={() => handleSearchTxtClear()}
                    >
                      Clear
                    </button>
                  </div>
                  <Row>
                    <Col>
                      <input
                        type="text"
                        value={searchQuery}
                        placeholder="Ex: Design or Tech"
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
            <Row className="catalog-scroll">
              <Col>
                <form>
                  <label className="left-panel-head col-md-6 py-4 fw-bold">
                    Catalogs
                  </label>
                  <div className="catalogs-insights-clear">
                    <button
                      onClick={() => handleCatalogClear()}
                      disabled={isClearDisabled}
                    >
                      Clear
                    </button>
                  </div>

                  {catalogList.map((catalog) => {
                    return (
                      <Col key={catalog} className="col-md-6 py-1 catalog-col">
                        <OverlayTrigger
                          placement="right"
                          overlay={<Tooltip>{catalog}</Tooltip>}
                        >
                          <Button
                            variant={
                              catalogFilterList.includes(catalog)
                                ? "primary"
                                : "outline-primary"
                            }
                            size="sm"
                            className="catalogBtn"
                            onClick={() => handleCatalogSearch(catalog)}
                          >
                            {catalog}
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    );
                  })}
                </form>
              </Col>
            </Row>
          </div>

          <Row className="right-panel-main-div">
            <Row className="right-panel-middle-div">
              <Col className="middle-card-alignment">
                {loading ? (
                  <div className="loader-card-container">
                    <div className="loader-card">
                      <div className="loader-spinner-wrapper">
                        <Spinner
                          animation="border"
                          role="status"
                          style={{ width: "3rem", height: "3rem" }}
                        >
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                      <div className="loader-fact-wrapper">
                        <div className="fact-text">{fact}</div>
                      </div>
                      <div className="fact-navigator-dots">
                        {factsArray.map((f, idx) => (
                          <span
                            key={idx}
                            className={`fact-dot${factIndex === idx ? " active" : ""}`}
                            onClick={() => goToFact(idx)}
                            style={{ cursor: "pointer" }}
                          ></span>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  filteredData.map((item) => (
                    <BeLaunchifiedCard
                      key={item.key}
                      title={item.title}
                      link={item.link}
                      duration={item.duration}
                      description={item.description}
                      status={item.status}
                    />
                  ))
                )}
              </Col>
            </Row>
          </Row>
        </Row>
      </Container>
      <div>
        <br></br>
      </div>
    </div>
  );
}

export default BeLaunchifiedComponent;
